import React from "react";
import {
  Plane,
  ChevronDown,
  Edit2,
  ArrowLeftRight,
  Share2,
} from "lucide-react";
import { format } from "date-fns";

export default function SearchSummaryBar(props) {
  const {
    setOpen,
    open,
    FormData,
    onSetShare,
    onShare,
  } = props;

  const formatCabinClass = (str) => {
    return str
      .toLowerCase()
      .split("_")
      .map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(" ");
  };

  const handleShare = () => {
    onSetShare(true);
  };

  return (
    <div
      className="
       sticky
        top-[64px]
        z-20
        w-full
        bg-white
        shadow-md
        rounded-md
      "
    >
      <div className="max-w-7xl mx-auto px-4 py-3">

        {/* ---------------- Mobile ---------------- */}
        <div className="flex md:hidden items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="font-bold truncate">
              {FormData.fromCode}
              <span className="mx-1">→</span>
              {FormData.toCode}
            </p>

            <p className="text-sm text-gray-500 truncate">
              {format(
                new Date(FormData.departureDate),
                "dd MMM yyyy"
              )}{" "}
              |{" "}
              {parseInt(FormData.adults) +
                parseInt(FormData.children) +
                parseInt(FormData.infants)}{" "}
              Pax | {formatCabinClass(FormData.selectedClass)}
            </p>
          </div>

          <div className="flex items-center gap-2 shrink-0">
            {/* Share */}
            <button
              type="button"
              onClick={() => onSetShare((v) => !v)}
              className="
                flex items-center justify-center
                w-9 h-9
                border border-gray-300
                rounded-md
                hover:bg-gray-50
              "
              title="Share"
            >
              <Share2 className="w-4 h-4 text-gray-700" />
            </button>

            {/* Modify */}
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="
                flex items-center gap-1
                border border-gray-400
                px-3 py-2
                rounded-md
                hover:bg-gray-50
                text-sm
                font-semibold
              "
            >
              <Edit2 className="w-4 h-4" />
              MODIFY
            </button>
          </div>
        </div>

        {/* ---------------- Desktop ---------------- */}
        <div className="hidden md:flex items-center justify-between gap-6">

          {/* Left side details */}
          <div className="flex flex-1 items-center gap-8 min-w-0">

            {/* Route */}
            <div className="flex items-center gap-2 shrink-0">
              <div>
                <p className="font-extrabold leading-tight">
                  {FormData.fromCode}
                </p>

                <p className="text-xs text-gray-400">
                  {FormData.from}
                </p>
              </div>

              {FormData.routeType == 2 ? (
                <ArrowLeftRight className="w-5 h-5 text-gray-400" />
              ) : (
                <Plane className="w-5 h-5 text-gray-400" />
              )}

              <div>
                <p className="font-extrabold leading-tight">
                  {FormData.toCode}
                </p>

                <p className="text-xs text-gray-400">
                  {FormData.to}
                </p>
              </div>
            </div>

            {/* Departure Date */}
            <div className="shrink-0">
              <p className="text-gray-400 text-sm font-medium">
                Departure Date
              </p>

              <p className="font-semibold">
                {format(
                  new Date(FormData.departureDate),
                  "dd MMM yyyy"
                )}
              </p>
            </div>

            {/* Return Date */}
            {FormData.routeType == 2 && (
              <div className="shrink-0">
                <p className="text-gray-400 text-sm font-medium">
                  Return Date
                </p>

                <p className="font-semibold">
                  {format(
                    new Date(FormData.returnDate),
                    "dd MMM yyyy"
                  )}
                </p>
              </div>
            )}

            {/* Pax & Class */}
            <div className="shrink-0">
              <p className="text-gray-400 text-sm font-medium">
                Passengers & Class
              </p>

              <p>
                <span className="text-blue-500 font-semibold">
                  {FormData.adults} Adult{" "}

                  {FormData.children > 0 &&
                    `${FormData.children} Child `}

                  {FormData.infants > 0 &&
                    `${FormData.infants} Infants`}
                </span>

                {" | "}

                {formatCabinClass(FormData.selectedClass)}
              </p>
            </div>

            {/* Preferred Airline */}
            <div className="shrink-0">
              <p className="text-gray-400 text-sm font-medium">
                Preferred Airline
              </p>

              <p>None</p>
            </div>
          </div>

          {/* Right side buttons */}
          <div className="flex items-center gap-2 shrink-0">

            {/* Share Button */}
            <button
              type="button"
              onClick={handleShare}
              className="
                flex items-center justify-center gap-2
                h-10
                px-4
                rounded-md
                bg-[#f4a406]
                text-white
                font-semibold
                text-sm
                shadow-sm
                hover:bg-[#df9200]
                hover:shadow-md
                transition-all
                duration-200
                animate-pulse
              "
              title="Share Flight Details"
            >
              <Share2 className="w-4 h-4" />
              <span>Share</span>
            </button>

            {/* Modify Search */}
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="
                flex items-center gap-2
                border border-gray-400
                px-4 py-2
                rounded-md
                hover:bg-gray-50
                text-sm
                font-semibold
                whitespace-nowrap
              "
            >
              MODIFY SEARCH

              <ChevronDown
                size={18}
                className={`
                  transition-transform
                  duration-200
                  ${open ? "rotate-180" : ""}
                `}
              />
            </button>

          </div>
        </div>
      </div>
    </div>
  );
}